import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

/** The tax codes under Ledger: each tax, its total rate and its entity. */
export function TaxCodesView() {
  const {
    columns,
    rows,
    loading,
    totalCount,
    deleteNodeButtonProps,
    loadNext,
    networkStatus,
  } = useConnectionSetup({ appView: "tax-codes" });
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={rows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      placeholderRow={Objects.TaxObject.placeholder}
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-TaxObject",
        })
      }
    />
  );
}
